import { useEffect, useState } from 'react';

const useDetectPWAMode = () => {
  const [isPWA, setIsPWA] = useState(false);

  useEffect(() => {
    function detectPWAMode() {
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
      const supportsPushAPI = 'PushManager' in window;
      const supportsCacheAPI = 'caches' in window;
      const isSafari = navigator.userAgent.toLowerCase().includes('safari');
      const isIphone = /iPhone/.test(navigator.userAgent);
      const isChrome = navigator.userAgent.indexOf('Chrome') > -1;

      if (isStandalone && supportsPushAPI && supportsCacheAPI && isSafari && isIphone && !isChrome) {
        setIsPWA(true);
      }
    }

    detectPWAMode();
  }, []);

  return { isPWA };
};

export default useDetectPWAMode;
